import HomePage from "../pages/client-side/homepage";
import ContactPage from "../pages/client-side/contactus-page";
import AboutUs from "../pages/client-side/aboutus-page";
import CasinosPage from "../pages/client-side/casinos-page";
import ResponsibleGamingPage from "../pages/client-side/responsiblegambling-page";
import PrivacyPolicyPage from "../pages/client-side/privacypolicy-page";
import BlogDetails from "../pages/client-side/BlogsDetails";
import CampaignRedirect from "../components/CampaignRedirect";
import BlogsPage from "../pages/client-side/blogs-page";
import CasinoReviewPage from "../pages/client-side/casino-review-page";

const routes = {
  public: [
    { path: "/", element: HomePage },
    { path: "/contact", element: ContactPage },
    { path: "/casinos", element: CasinosPage },
    { path: "/about", element: AboutUs },
    { path: "/blogs", element: BlogsPage },
    { path: "/blog/:slug", element: BlogDetails },
    { path: "/:casinoName-review", element: CasinoReviewPage },
    { path: "/responsible-gambling", element: ResponsibleGamingPage },
    { path: "/privacy-policy", element: PrivacyPolicyPage },
    { path: "/campaign/:slug", element: CampaignRedirect },
  ],
  dashboard: [
    // { path: "/maindashboard", element: MainDashboard },
  ],
  admin: [],
};

export default routes;
